import React, { useState } from 'react'

import { CheckoutHeader } from '@src/components/CheckoutModal/CheckoutHeader'
import { LoadingSpinner } from '@src/components/Loaders/LoadingSpinner'
import { BasketOutletProvider } from '@src/hooks/outletFulfilmentAndBasketHooks/useOutletFulfilment/context/BasketOutletProvider'
import { useBasketOutletId } from '@src/hooks/useBasketOutletId'
import {
  CheckoutRoute,
  useCheckoutRouter,
} from '@src/hooks/useCheckoutRouter/useCheckoutRouter'
import { BasketTotalsProvider } from '@src/hooks/useTotals/BasketTotalsContext'

import { AddOnItems } from './AddOnItems/AddOnItems'
import { CheckoutSuccess } from './CheckoutSuccess'
import { FulfilmentSteps } from './FulfilmentSteps'
import { PaymentStep } from './PaymentStep/PaymentStep'

import { BasketSummary } from '../BasketSummary'
import { EmptyBasket } from '../BasketSummary/EmptyBasket'

export const Checkout: React.FC = () => {
  const checkoutRouter = useCheckoutRouter()
  const { basketOutletId } = useBasketOutletId()
  const [manualLoadingState, setManualLoadingState] = useState(false)
  const [addOnItemsHeader, setAddOnItemsHeader] = useState('')

  const getContent = () => {
    if (
      checkoutRouter.defaultedRoute !== CheckoutRoute.COMPLETE &&
      !basketOutletId
    ) {
      return <EmptyBasket />
    }

    switch (checkoutRouter.defaultedRoute) {
      case CheckoutRoute.BASKET:
        return <BasketSummary />
      case CheckoutRoute.FULFILMENT:
        return <FulfilmentSteps />
      case CheckoutRoute.PAYMENT:
        return <PaymentStep />
      case CheckoutRoute.OFFERS:
        return (
          <AddOnItems
            setManualLoadingState={setManualLoadingState}
            setAddOnItemsHeader={setAddOnItemsHeader}
          />
        )
      case CheckoutRoute.PAYMENT_REDIRECT_VERIFICATION:
        // TODO: Skeleton loader
        return <LoadingSpinner />
      case CheckoutRoute.COMPLETE:
        return <CheckoutSuccess />
    }
  }

  return (
    <>
      <CheckoutHeader
        manualLoadingState={manualLoadingState}
        addOnItemsHeader={addOnItemsHeader}
      />
      {checkoutRouter.defaultedRoute === CheckoutRoute.COMPLETE && (
        <CheckoutSuccess />
      )}
      {checkoutRouter.defaultedRoute !== CheckoutRoute.COMPLETE &&
        !basketOutletId && <EmptyBasket />}

      {checkoutRouter.defaultedRoute !== CheckoutRoute.COMPLETE &&
        basketOutletId && (
          <BasketOutletProvider>
            <BasketTotalsProvider>{getContent()}</BasketTotalsProvider>
          </BasketOutletProvider>
        )}
    </>
  )
}
